module.exports = __webpack_public_path__ + "static/img/Pic-mhd.f402034.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/Pic-mhd.png
// module id = +qW5
// module chunks = 63